// PRODUCT-2831: Vero staff never reset or verify from the manager portal. Name
// where the action lives instead of saying the permission is missing.
export const INTERNAL_USER_VERIFY_DISABLED_REASON =
  "Identity checks can only be verified by the property team.";
export const INTERNAL_USER_RESET_DISABLED_REASON =
  "If you need to reset the applicant's check for any reason, escalate to your manager at VERO.";
